export default __webpack_public_path__ + "static/media/Letters2_20.5539ba85.png";